import { StoreConfig, Store } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { IOrganizationUnitCustomerDetails } from './organization-unit-customer-details.service';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'organization-unit-customer-details' })
export class OrganizationUnitCustomerDetailsStore extends Store<IOrganizationUnitCustomerDetails> {
  constructor() {
    super({});
  }
}